import { type ExtractEnum } from 'graphql-schema';

type ShirtSizeEnum = ExtractEnum<'shirt_size_enum'>;

export const SizingEnum = Object.freeze({
  SMALL: 'Small',
  MEDIUM: 'Medium',
  LARGE: 'Large',
  X_LARGE: 'X-Large',
  XX_LARGE: 'XX-Large',
});

type SizingEnumValues = (typeof SizingEnum)[keyof typeof SizingEnum];

export const SizingNameEnum = Object.freeze<Record<SizingEnumValues, ShirtSizeEnum>>({
  [SizingEnum.SMALL]: 's',
  [SizingEnum.MEDIUM]: 'm',
  [SizingEnum.LARGE]: 'l',
  [SizingEnum.X_LARGE]: 'xl',
  [SizingEnum.XX_LARGE]: 'xxl',
});
